var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 71,
    viewBox: "0 0 57 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 25.3603H51.8237V22.8198C51.7933 10.2214 41.3648 0.0148567 28.4924 0C15.62 0.0148567 5.19148 10.2214 5.1763 22.8198V25.3603H0V71H57V25.3603ZM10.3678 22.8198C10.3678 9.83511 24.6064 0.118854 38.6325 7.78489C43.5963 10.5037 46.6322 15.6441 46.6322 21.2005V25.3455H10.3678V22.8198ZM51.8085 65.919H5.1763V30.4265H51.8085V65.919Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8245 43.0989C34.7316 40.0533 31.7867 38.0179 28.4927 38.0328C24.212 38.0179 20.7359 41.4201 20.7207 45.6097C20.7207 48.8336 22.7851 51.7158 25.897 52.7855V58.327C25.897 59.7235 27.0507 60.8675 28.4927 60.8675C29.9348 60.8675 31.0885 59.7384 31.0885 58.327V52.7855C35.1263 51.3889 37.2514 47.0508 35.8245 43.0989ZM28.4927 48.1799C27.0658 48.1799 25.897 47.0508 25.897 45.6394C25.897 44.228 27.0507 43.0989 28.4927 43.0989C29.9348 43.0989 31.0885 44.228 31.0885 45.6394C31.0885 47.0508 29.9348 48.1799 28.4927 48.1799Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.42ec0c04d516e0ec784730971cce89b8.svg";
export { ForwardRef as ReactComponent };